module.exports = __webpack_public_path__ + "static/media/WebDev-md_2x.a87745ba.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/WebDev/WebDev-md_2x.webp
// module id = 772
// module chunks = 0